(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tickr-buy-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tickr-buy-gallery')) {
    customElements.define('tickr-buy-gallery', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.initialize(), { once: true, signal: this.controller.signal });
        } else this.initialize();
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      initialize() {
        if (!this.isConnected) return;
        this.controls = this.querySelector('[data-tbg-controls]');
        this.buttons = Array.from(this.querySelectorAll('[data-tbg-target]'));
        this.slides = Array.from(this.querySelectorAll('[data-tbg-slide]'));
        this.status = this.querySelector('[data-tbg-status]');
        if (!this.controls || this.buttons.length < 2 || this.buttons.length !== this.slides.length || this.buttons.some((button, index) => button.dataset.tbgTarget !== this.slides[index].id)) return;
        const options = { signal: this.controller.signal };
        this.buttons.forEach((button, index) => {
          button.addEventListener('click', () => this.selectImage(index), options);
          button.addEventListener('keydown', event => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % this.buttons.length;
            else if (event.key === 'ArrowLeft') next = (index - 1 + this.buttons.length) % this.buttons.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.buttons.length - 1;
            else return;
            event.preventDefault();
            this.selectImage(next);
            this.buttons[next].focus({ preventScroll: true });
          }, options);
        });
        this.addEventListener('shopify:block:select', event => {
          const index = this.slides.indexOf(event.target.closest('[data-tbg-slide]'));
          if (index >= 0) this.selectImage(index, false);
        }, options);
        this.selectImage(0, false);
        this.controls.hidden = false;
        this.setAttribute('data-tbg-enhanced', '');
      }

      selectImage(index, announce = true) {
        if (index < 0 || index >= this.slides.length) return;
        this.slides.forEach((slide, position) => {
          slide.hidden = position !== index;
          this.buttons[position].setAttribute('aria-pressed', String(position === index));
        });
        const image = this.slides[index].querySelector('img');
        if (announce && image) image.loading = 'eager';
        if (announce && this.status) this.status.textContent = image?.alt || this.buttons[index].getAttribute('aria-label');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tickr-home-cta"] && !Shopify.designMode) return;
  try {
    (() => {
    let stopFollowingLayout = () => {};
    const stackedLayout = window.matchMedia('(max-width: 989px)');
    const getSelector = () => {
      const selector = Array.from(document.querySelectorAll('[data-tickr-buy-target]')).find(target => target.getClientRects().length);
      if (!selector) return;
      const section = selector.closest('tickr-home-buy');
      const landing = stackedLayout.matches
        ? section?.querySelector('[data-tickr-buy-landing="mobile"]') || section?.querySelector('[data-tickr-buy-landing="info"]')
        : section?.querySelector('[data-tickr-buy-landing="desktop"]');
      return landing?.getClientRects().length ? landing : selector;
    };
    const scrollToSelector = (target, reducedMotion) => {
      stopFollowingLayout();
      const content = target.closest('main') || document.body;
      let height = content.getBoundingClientRect().height;
      let timeout;
      const observer = new ResizeObserver(() => {
        const nextHeight = content.getBoundingClientRect().height;
        if (Math.abs(nextHeight - height) > 1 && target.isConnected) {
          height = nextHeight;
          target.scrollIntoView({ behavior: 'instant', block: 'start' });
        }
      });
      const cancelEvents = ['wheel', 'touchstart', 'pointerdown', 'keydown'];
      const stop = () => {
        observer.disconnect();
        clearTimeout(timeout);
        cancelEvents.forEach(name => window.removeEventListener(name, stop));
      };
      stopFollowingLayout = stop;
      cancelEvents.forEach(name => window.addEventListener(name, stop, { passive: true, once: true }));
      observer.observe(content);
      timeout = setTimeout(stop, 5000);
      target.focus({ preventScroll: true });
      target.scrollIntoView({ behavior: reducedMotion ? 'instant' : 'smooth', block: 'start' });
    };
    const updateLinks = () => {
      const target = getSelector();
      document.querySelectorAll('a[data-tickr-choose]').forEach(link => {
        link.setAttribute('href', target ? `#${target.id}` : link.dataset.productUrl);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateLinks, { once: true });
    else updateLinks();
    document.addEventListener('shopify:section:load', updateLinks);
    document.addEventListener('shopify:section:unload', () => requestAnimationFrame(updateLinks));
    document.addEventListener('shopify:section:reorder', updateLinks);
    stackedLayout.addEventListener('change', () => {
      stopFollowingLayout();
      updateLinks();
    });
    document.addEventListener('click', event => {
      const link = event.target.closest('a[data-tickr-choose]');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const target = getSelector();
      if (!target) { link.setAttribute('href', link.dataset.productUrl); return; }
      event.preventDefault();
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      scrollToSelector(target, reducedMotion);
      history.replaceState(history.state, '', `#${target.id}`);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tickr-homey-foundation"] && !Shopify.designMode) return;
  try {
    function tickrHomeyInit(root) {
    if (!root || root.dataset.tmxReady === 'true') return;
    root.dataset.tmxReady = 'true';

    const revealItems = root.querySelectorAll('.tmx-reveal');
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      revealItems.forEach((item) => observer.observe(item));
    } else {
      revealItems.forEach((item) => item.classList.add('is-visible'));
    }

    const storyTrack = root.querySelector('[data-tmx-story-track]');
    root.querySelectorAll('[data-tmx-story-direction]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!storyTrack) return;
        const direction = button.dataset.tmxStoryDirection === 'next' ? 1 : -1;
        storyTrack.scrollBy({ left: storyTrack.clientWidth * 0.78 * direction, behavior: 'smooth' });
      });
    });

    const dashboardTabs = root.querySelectorAll('[data-tmx-dashboard-tab]');
    const dashboardPanels = root.querySelectorAll('[data-tmx-dashboard-panel]');
    dashboardTabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.tmxDashboardTab;
        dashboardTabs.forEach((item) => item.setAttribute('aria-selected', item === tab ? 'true' : 'false'));
        dashboardPanels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.tmxDashboardPanel === target));
      });
    });
  }

  document.querySelectorAll('[data-tmx-home]').forEach(tickrHomeyInit);
  document.addEventListener('shopify:section:load', (event) => {
    tickrHomeyInit(event.target.querySelector('[data-tmx-home]'));
  });
  } catch(e) { console.error(e); }
})();

})();
